import { jsx as _jsx } from "react/jsx-runtime";
import { EduIDButton } from "components/Common/EduIDButton";
import { forwardRef, useState } from "react";
import { FormattedMessage } from "react-intl";
export const CopyToClipboardButton = forwardRef((_props, ref) => {
    const [tooltipCopied, setTooltipCopied] = useState(false); // say "Copy to clipboard" or "Copied!" in tooltip
    function copyToClipboard() {
        if (ref && typeof ref === "object" && ref.current) {
            ref.current.select();
            navigator.clipboard.writeText(ref.current.value);
            setTooltipCopied(true);
            setTimeout(() => {
                setTooltipCopied(false);
            }, 10000);
        }
    }
    return (_jsx(EduIDButton, { buttonstyle: "link sm txt-toggle-btn", onClick: copyToClipboard, children: tooltipCopied ? (_jsx(FormattedMessage, { id: "copyToClipboardButton.button", defaultMessage: "COPIED", description: "copied button label" })) : (_jsx(FormattedMessage, { id: "copyToClipboardButton.label", defaultMessage: "COPY", description: "copy button label" })) }));
});
CopyToClipboardButton.displayName = "CopyToClipboardButton";
